import api from '@/api/index.js'

const offline_filter = {
  state: {
    loading: false,
    updating: false,
    data: null,
    error: null
  },

  mutations: {
    SET_OFFLINE_FILTER_LOADING: (state, v) => {
      state.loading = v
    },
    SET_OFFLINE_FILTER_UPDATING: (state, v) => {
      state.updating = v
    },
    SET_OFFLINE_FILTER: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_OFFLINE_FILTER_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    LoadOfflineFilter({commit}, query) {
      commit('SET_OFFLINE_FILTER', null)
      commit('SET_OFFLINE_FILTER_ERROR', null)
      commit('SET_OFFLINE_FILTER_LOADING', true)
      return api.get(`bloom-filters/${query.id}`)
        .then((response) => {
          commit('SET_OFFLINE_FILTER', response)
        })
        .catch((error) => {
          commit('SET_OFFLINE_FILTER_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_OFFLINE_FILTER_LOADING', false)
        })
    },
  }
}

export default offline_filter
